{
  "nav": {
    "pricing": "Fiyatlandırma",
    "contact": "İletişim",
    "menu": "Menü",
    "login": "Giriş yap",
    "features": "Özellikler",
    "brandHomeAria": "Done-it — ana sayfa",
    "market": {
      "belgium": "Belçika",
      "international": "Dünya geneli"
    }
  },
  "footer": {
    "tagline": "Done-it — Basit zaman takibi.",
    "terms": "Şartlar",
    "privacy": "Gizlilik",
    "contact": "İletişim"
  },
  "help": "Yardıma mı ihtiyacınız var?",
  "continue": "Devam",
  "back": "Geri",
  "change": "Değiştir",
  "retry": "Tekrar dene",
  "errors": {
    "unexpected": "Beklenmeyen hata"
  },
  "step": {
    "of": "Adım {{n}} / {{total}}"
  },
  "funnel": {
    "title": "Abonelik · Done-it"
  }
}
